import shiptypeCreateComponent from './shiptype.create.component';

let shiptypeCreateModule = angular.module('shiptypecreate', [
  ])

  .component('shiptypecreate', shiptypeCreateComponent)

  .name;

export default shiptypeCreateModule;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/shiptype/create/index.js